var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F8F4EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.0625V12.9375C13.5 12.3408 13.2629 11.7685 12.841 11.3465C12.419 10.9246 11.8467 10.6875 11.25 10.6875H6.75C6.15326 10.6875 5.58097 10.9246 5.15901 11.3465C4.73705 11.7685 4.5 12.3408 4.5 12.9375V14.0625",
    stroke: "#141414",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.4375C10.2426 8.4375 11.25 7.43014 11.25 6.1875C11.25 4.94486 10.2426 3.9375 9 3.9375C7.75736 3.9375 6.75 4.94486 6.75 6.1875C6.75 7.43014 7.75736 8.4375 9 8.4375Z",
    stroke: "#141414",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/user-fill.be8461232ec8bc53603d84086dd32e80.svg";
export { ForwardRef as ReactComponent };